import { AssignProfessionalDomainPayload } from './AssignProfessionalMapper.types'

class AssignProfessionalMapper {
  toPersistence(domainData: AssignProfessionalDomainPayload) {
    return {
      id: domainData?.id,
      idProfissional: domainData?.professionalId,
    }
  }
}

export default new AssignProfessionalMapper()
